import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useCookies } from "react-cookie";
import { isEmpty } from "../../utility";
import SubForm from "../Footer/SubForm";

const SubscribeForm = ({ status, message, onValidated }) => {
  const [cookies, setCookie] = useCookies(false);
  const [subcookies, getCookie] = useCookies(false);
  console.log(subcookies.subscribed);
  function setCooksSub() {
    setCookie("subscribed", true, { maxAge: "31540000" });
    //7884000
    alert(document.cookie.split(";").join(";\r\n"));
    // alert(now.toUTCString());
  }
  const setCooksCancel = () => {
    setCookie("subscribed", true, { maxAge: "7884000" });
  };

  let userSub = subcookies.subscribed;
  if (!userSub) {
    setTimeout(function () {
      handleShow();
      setCookie("subscribed", false);
    }, 60000);
  }

  const [show, setShow] = useState(false);
  const [subScribe, setSubScribe] = useState({
    email: "",
    fname: "",
  });
  const [subScribeE, setSubScribeE] = useState({
    email: "",
    fname: "",
  });
  const [validator, setValidator] = useState(false);
  function sumbitForm() {
    if (checkInput) {
      subScribe.email &&
        subScribe.fname &&
        subScribe.email.indexOf("@") > -1 &&
        onValidated({
          EMAIL: subScribe.email,
          FNAME: subScribe.fname,
        });
    }
  }
  const checkInput = () => {
    let isModalerror = false;
    if (isEmpty(subScribe?.fname) || subScribe?.fname.length < 3) {
      setSubScribeE((prevState) => ({
        ...prevState,
        fname: "Full Name is required and must be at least 3 characters",
      }));
      isModalerror = true;
    }

    let mailformat =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (isEmpty(subScribe?.email) || !mailformat.test(subScribe?.email)) {
      setSubScribeE((prevState) => ({
        ...prevState,
        email: "Plese Provide a Valid Email Address",
      }));
      isModalerror = true;
    }

    if (isModalerror) {
      setValidator(false);
    } else {
      setValidator(true);
    }
    return true;
  };

  const handleChange = (e) => {
    setSubScribe((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
    checkInput();
  };

  const handleClose = () => {
    setCooksCancel();
    setShow(false);
  };
  const handleShow = () => {
    setShow(true);
  };
  return (
    <>
      <Modal
        // size="lg"
        centered
        show={show}
        onHide={handleClose}
        backdrop="static"
      >
        <Modal.Header
          className="modeHead"
          closeButton
          style={{ padding: "20px" }}
        />
        {!status ? (
          <>
            <div className="wrapper">
              <div className="image">
                <i className="fas fa-envelope"></i>
              </div>
              <h1>Subscribe</h1>
              <p>Subscribe to our newsletter and stay updated on .</p>
            </div>

            <div className="wrapper">
              <div className="input-group input-group-icon">
                <input
                  value={subScribe.fname}
                  className="subInput"
                  type="text"
                  placeholder="Full Name"
                  onChange={handleChange}
                  name="fname"
                  autoComplete="off"
                />
                <div className="input-icon">
                  <i className="fa fa-user"></i>
                </div>
              </div>

              <div className="input-group input-group-icon">
                <input
                  value={subScribe.email}
                  className="subInput"
                  type="email"
                  placeholder="Email Adress"
                  onChange={handleChange}
                  name="email"
                  autoComplete="off"
                />
                <div className="input-icon">
                  <i className="fa fa-envelope"></i>
                </div>
              </div>

              <button
                className="btn p-2 buttan"
                type="submit"
                disabled={!validator}
                onClick={sumbitForm}
              >
                Subscribe
              </button>
            </div>
          </>
        ) : (
          ""
        )}
        {status === "sending" && (
          <>
            <div className="spin-wrapper">
              <span className="loader"></span>
            </div>
          </>
        )}
        {status === "success" && (
          <div className="wrapper" style={{ padding: "9em" }}>
            <div className="head">
              <h1 style={{ textAlign: "center" }}>
                <div className="checkmark-circle">
                  <div className="background"></div>
                  <div className="checkmark draw"></div>
                </div>
              </h1>{" "}
            </div>
            {window.location.reload()}
            {setCooksSub()}
          </div>
        )}
        {status === "error" && (
          <>
            {alert(message)}
            {window.location.reload()}
          </>
        )}
      </Modal>
    </>
  );
};

export default SubscribeForm;
